"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecCheckout = void 0;
const enums_1 = require("../enums");
const buildEecProduct_1 = require("./buildEecProduct");
const pushToDataLayer_1 = require("./pushToDataLayer");
const clearGA4EventData_1 = require("./clearGA4EventData");
const buildGA4ProductDetail_1 = require("./buildGA4ProductDetail");
const getVariant_1 = require("../helper/getVariant");
const mapCartProductToProduct_1 = require("../helper/mapCartProductToProduct");
const getCheckoutEventName = (step) => {
    switch (step) {
        case enums_1.CheckoutStep.CART:
            return enums_1.GA4EventName.ViewCart;
        case enums_1.CheckoutStep.CHECKOUT:
            return enums_1.GA4EventName.BeginCheckout;
        case enums_1.CheckoutStep.LAST_CHECK:
            return enums_1.GA4EventName.CheckoutOverview;
        default:
            throw new Error('invalid checkout step');
    }
};
const buildGA4CheckoutEvent = (cart, step) => {
    const isCheckoutOrCart = step === enums_1.CheckoutStep.CHECKOUT || step === enums_1.CheckoutStep.CART;
    const ecommerce = isCheckoutOrCart
        ? {
            items: cart.items.map(({ product, appointment, quantity }) => (0, buildGA4ProductDetail_1.buildGA4ProductDetail)({
                product: (0, mapCartProductToProduct_1.mapCartProductToProduct)(product),
                quantity,
                variant: (0, getVariant_1.getVariant)(appointment, product.productType),
                appointment,
            })),
        }
        : undefined;
    const paymentType = step === enums_1.CheckoutStep.LAST_CHECK ? cart.selectedPaymentType : undefined;
    return {
        eventData: {
            eventName: getCheckoutEventName(step),
            feature_category: enums_1.GA4FeatureCategory.Ecommerce,
            ...(ecommerce && { ecommerce }),
            ...(paymentType && { payment_type: paymentType }),
        },
    };
};
function trackEecCheckout(cart, step) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: enums_1.EventName.EECCheckout,
        ecommerce: {
            currencyCode: cart.total.gross.currencyCode,
            checkout: {
                actionField: {
                    step,
                },
                products: cart.items.map(({ product, quantity, appointment }) => (0, buildEecProduct_1.buildEecProduct)({
                    product,
                    quantity,
                    appointment,
                })),
            },
        },
        ...buildGA4CheckoutEvent(cart, step),
    });
}
exports.trackEecCheckout = trackEecCheckout;
//# sourceMappingURL=trackEecCheckout.js.map